module.exports = __webpack_public_path__ + "img/guide_4_5.161f03d2.svg";